export const ESimStatus = {
    InTransit: 'InTransit',
    Inventory: 'Inventory',
    Active: 'Active',
    Suspended: 'Suspended',
    Terminated: 'Terminated',
    Distinctive: 'Distinctive',
};
